/*
 * chatbot Actions
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 16-Apr-2025
 */

import { createAction } from './index'

export const actionTypes = {
  DO_CHATBOT_MOUNTED: 'chatbot/do_chatbot_mounted'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request

/** @action
 * * Insert a description
 * @name DoChatbotMounted
 * @return {object} - The payload object
 */
export const doChatBotMounted = payload => createAction(actionTypes.DO_CHATBOT_MOUNTED, { payload })
// @generator action
